var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://vm-api.knpis.eduvisionpro.com';
} else {
    service.API_URL = 'https://vm-api.knpis.eduvisionpro.com';
}

export default service;
